<template>
    
    <content-wrapper class="m-0 p-0">
        
        <!-- Show month and year only using native month picker -->
        <input
            id="startDate"
            type="month"
            v-model="searchForm.monthYear"
            :max="searchForm.maxMonth"
            class="form-control mb-3"
            aria-label="Month and Year"
            placeholder="Month and Year"
            @change="changeDate"
        />
        
        <table class="table">
            <thead>
            <tr>
                <th scope="col">#</th>
                <th scope="col">Trucking</th>
                <th scope="col">Intensity</th>
            </tr>
            </thead>
            <tbody>
                <template v-if="localTrucking.status == undefined">
                    <tr v-for="n in shimmerRows" :key="'shimmer-'+n">
                        <th scope="row"><div class="shimmer shimmer-circle"></div></th>
                        <td><div class="shimmer shimmer-text short"></div></td>
                        <td><div class="shimmer shimmer-text"></div></td>
                    </tr>
                </template>
                <template v-else>
                    <tr v-if="!localTrucking.data.length">
                        <td colspan="3" class="text-center"><i>- no data -</i></td>
                    </tr>
                    <tr v-for="(trucks, index) in localTrucking.data" :key="index">
                        <th scope="row">{{ index + 1 }}</th>
                        <td>{{ trucks.name }}</td>
                        <td>{{ trucks.intensity }}</td>
                    </tr>
                </template>
            </tbody>
        </table>

        <div v-if="localTrucking.data && localTrucking.data.length > 0" class="mt-2 text-right">
            <button class="btn btn-sm btn-link" @click="expandClick">
                &nbsp;<span>Show more</span>&nbsp;
            </button>
        </div>

        <b-modal
            centered
            header-bg-variant="info"
            id="showTruckingModal" 
            size="xl"
            :title="'Trucking of The Month in ' + formatMonthYear(searchForm.monthYear)">

            <b-row class="mb-3">
                <b-col>
                    <b-input-group>
                        <b-form-input
                            placeholder="Keywords"
                            v-model="searchKeywords"
                            @keyup.enter="handleSearch"
                        />
                        <b-input-group-append>
                            <b-button variant="primary" @click="handleSearch">
                            <b-icon icon="search" />
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <div class="d-flex justify-content-center">
                        <button v-if="isLoading" class="btn btn-sm btn-link mb-3">
                            <b-spinner small></b-spinner>
                            &nbsp;<span>Loading ...</span>&nbsp;
                        </button>
                    </div>
                </b-col>
            </b-row>

            <b-table class="table"
                ref="table"
                id="table"
                :per-page="pagination.per_page"
                :current-page="pagination.current_page"
                :items="expand"
                :fields="columns"
                :busy.sync="isLoading"
                striped
                borderless
                outlined
                show-empty
                empty-text="No records found..."
                stacked="sm">
                <template #cell(no)="data">
                    {{ (pagination.current_page - 1) * pagination.per_page + data.index + 1 }}
                </template>
            </b-table>

            <!-- pagination -->
            <div class="d-flex justify-content-center">
                <laravel-pagination :pagination="pagination" @change="changePage" />
            </div>

            <!-- modal footer: single Close button -->
            <template #modal-footer>
                <b-button variant="secondary" @click="searchKeywords='';$bvModal.hide('showTruckingModal');">
                    Close
                </b-button>
            </template>

        </b-modal>

    </content-wrapper>
    
</template>

<script>
import { getFrequentlyTrucking, allFrequentlyTrucking } from "@/services/persero_btm";
import LaravelPagination from "@/components/LaravelPagination";
export default {
    name: 'FrequentlyTruckingTable',
    components: {
        LaravelPagination
    },
    props: {
        trucking: {
            type: [Array, Object],
            default: () => []
        },
        shimmerRows: {
            type: Number,
            default: 10
        }
    },
    watch: {
        trucking: {
            handler(newVal) {
            this.localTrucking = newVal
            },
            deep: true,
            immediate: true
        }
    },
    data() {
        // compute current month in YYYY-MM format for default value
        const now = new Date();
        const yyyy = now.getFullYear();
        const mm = String(now.getMonth() + 1).padStart(2, '0');
        const currentMonth = `${yyyy}-${mm}`;

        return {
            isLoading: false,
            searchForm: {
                monthYear: currentMonth,
                maxMonth: currentMonth
            },
            localTrucking: this.trucking && this.trucking.data
                ? this.trucking
                : { status: undefined, data: [] },
            expandTrucking: [],
            pagination: { // based on Laravel pagination response
                current_page: 1,
                first_page_url: '',
                from: 1,
                last_page: 1,
                last_page_url: '',
                links: [],
                next_page_url: '',
                path: '',
                per_page: 10,
                prev_page_url: '',
                to: 10,
                total: 10,
            },
            filters: {},
            columns: [
                { key: 'no', label: 'No', sortable: false },
                { key: 'name', label: 'Trucking', sortable: false },
                { key: 'intensity', label: 'Intensity', sortable: false },
            ],
            searchKeywords: ''
        }
    },
    methods:{
        handleSearch(){
            console.log('handleSearch', this.searchKeywords);
            this.$refs.table.refresh();
        },
        async changeDate(){
            this.localTrucking = []; // reset trucking data to show shimmer
            console.log('monthYear',this.searchForm.monthYear);
            const [year, month] = this.searchForm.monthYear.split('-');
            const filterMonthYear = await getFrequentlyTrucking(month, year);
            this.localTrucking = JSON.parse(filterMonthYear);
        },
        changePage(page) {
            this.pagination.current_page = page;
            this.$refs.table.refresh();
        },
        async expandClick(){
            this.clearPagination();
            this.$bvModal.show('showTruckingModal');
            this.$nextTick(() => {
                this.$refs.table.refresh();
                return;
            });
        },
        async expand() {
            console.log('expand dipanggil');

            try{
                const keywords = (this.searchKeywords !== null && this.searchKeywords !== '') ? this.searchKeywords : null;

                const payload = {
                    ...this.pagination,
                    ...this.filters,
                };
                const [year, month] = this.searchForm.monthYear.split('-');
                const expand_data = await allFrequentlyTrucking(month, year, payload, keywords);
                const expand_data_json = JSON.parse(expand_data);
                this.expandTrucking = expand_data_json.status == 'success' ? expand_data_json.data.data : [];

                if(this.expandTrucking?.length > 0){
                    this.isLoading = false;

                    this.pagination = {
                        current_page: expand_data_json.data.current_page,
                        first_page_url: expand_data_json.data.first_page_url,
                        from: expand_data_json.data.from,
                        last_page: expand_data_json.data.last_page,
                        last_page_url: expand_data_json.data.last_page_url,
                        links: expand_data_json.data.links,
                        next_page_url: expand_data_json.data.next_page_url,
                        path: expand_data_json.data.path,
                        per_page: expand_data_json.data.per_page,
                        prev_page_url: expand_data_json.data.prev_page_url,
                        to: expand_data_json.data.to,
                        total: expand_data_json.data.total,
                    }
                    
                    return this.expandTrucking || [];
                }else{
                    this.isLoading = false;
                    return [];
                }
            }catch (error) {
                console.error("loadPage error", error);
                this.isLoading = false;
                return [];
            }
        },
        clearPagination(){
            this.pagination = { // based on Laravel pagination response
                current_page: 1,
                first_page_url: '',
                from: 1,
                last_page: 1,
                last_page_url: '',
                links: [],
                next_page_url: '',
                path: '',
                per_page: 10,
                prev_page_url: '',
                to: 10,
                total: 10,
            }
        },
        formatMonthYear(value) {
            if (!value) return '';

            const [year, month] = value.split('-');
            const monthNames = [
                'Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni',
                'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'
            ];

            return `${monthNames[parseInt(month) - 1]} ${year}`;
        }
    },
    mounted() {
        // pastikan expand selalu dipanggil dengan konteks Vue instance
        this.expand = this.expand.bind(this);
        // this.expand();
    }
}
</script>

<style scoped>
    .shimmer {
        display: inline-block;
        background: linear-gradient(90deg, #f0f0f0 25%, #e6e6e6 37%, #f0f0f0 63%);
        background-size: 400% 100%;
        animation: shimmer 1.2s ease-in-out infinite;
        border-radius: 4px;
    }

    /* circle for row number */
    .shimmer-circle {
        width: 28px;
        height: 18px;
        border-radius: 4px;
    }

    /* text blocks */
    .shimmer-text {
        height: 18px;
        width: 100%;
        border-radius: 4px;
    }

    .shimmer-text.short {
        width: 60%;
    }

        /* small spacing so it aligns in table cells */
    tbody td .shimmer,
    tbody th .shimmer {
        display: block;
        margin: 6px 0;
    }

    @keyframes shimmer {
        0% {
            background-position: -200% 0;
        }
        100% {
            background-position: 200% 0;
        }
    }
</style>